import TableResult from './TableResult';

export default TableResult
